import React, {useEffect} from 'react'
import {BasicLayout} from '../../modules/Layouts/basicLayout'
import {useHistory, useLocation} from 'react-router-dom'
import GeneracionFactura from './GeneracionFactura.page'
import ResumenFactura from './ResumenFactura.page'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionFacturacionCliente, actionFacturacionEmision} from '../../actions/action-creators'
import PrivateRoute from '../../routes/PrivateRoute'
import { docsAsociadosReset, setActiveModuleDoc } from '../../actions/documentos/documentos.actions'
import { State } from '../../reducers'
import ModalSalir from '../../components/Modals/Generales/ModalConfirmSalir'
import { handleRestartStateFormaPago } from '../../actions/forma-pago.actions'

const EmitirFacturaIndex = () => {
  const datosFacturaRes = useSelector((state:State) => state.facturacion.datosFacturaRes)
  const {sucursalesCargadas, catalogoSucursal} = useSelector((state:State) => state.facturacion)
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const {facturacionConsultarCatalogos} = bindActionCreators(actionFacturacionCliente, dispatch)
  const {facturacionClearAll} = bindActionCreators(actionFacturacionEmision, dispatch)
  const userLogin = useSelector((state: State) => state.userLogin)

  useEffect(() => {
    if(datosFacturaRes?.JsonFactura) history.push("/emitir-factura/resumen")
    facturacionConsultarCatalogos()
    window.scroll(0, 0)
    dispatch(setActiveModuleDoc({idDoc: '01', title: 'Factura'}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    window.scroll(0, 0)
    let url = location.pathname.toLowerCase()
    if (url.includes('/emitir-factura/')) {if (url === '/emitir-factura/formulario' || url === '/emitir-factura/resumen') return}
    history.push('/404')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <BasicLayout>
      <ModalSalir
        excludeValidate={sucursalesCargadas && (!catalogoSucursal || catalogoSucursal.length === 0)} 
        title='Salir de facturación' 
        onConfirmExit={() => {facturacionClearAll(true); dispatch(docsAsociadosReset()); dispatch(handleRestartStateFormaPago())}} 
        includeText='/emitir-factura/' 
      />
      <PrivateRoute exact path='/emitir-factura/formulario' component={GeneracionFactura} />
      <PrivateRoute exact path='/emitir-factura/resumen' component={ResumenFactura} />
    </BasicLayout>
  )
}

export default EmitirFacturaIndex
